import React from 'react';

export const GoogleForm = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <iframe 
        src="https://docs.google.com/forms/d/e/1FAIpQLSd0Hp1ZZdJzyrlWxmBEgEDyN33SmTid8olpIydlDEi93AwlIg/viewform?embedded=true" 
        width="100%" 
        height="100%" 
        frameBorder="0" 
        marginHeight="0" 
        marginWidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};